import React from "react";

export const AppInfo = (data: any) => {
  const {
    session_duration,
    session_price,
    five_session,
    three_session,
    ten_session,
    session_delivery_mode,
    tags,
    type,
    rating,
    title,
    details,
    voice_note_link,
    style,
    no_of_patients,
    feedback,
    certifications,
    approach_to_therapy,
    first_session,
    gender,
    audience_session_config,
  } = data;
  return (
    <div className="col-sm-12 mt-5">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Session Duration:</th>
            <td colSpan={3}>{session_duration}</td>
          </tr>
          <tr>
            <th scope="row">Inperson Session Price:</th>
            <td>{session_price.in_person}</td>
          </tr>
          <tr>
            <th scope="row">Video Session Price:</th>
            <td>{session_price.video}</td>
          </tr>
          <tr>
            <th scope="row">Call Session Price:</th>
            <td>{session_price.call}</td>
          </tr>
          <tr>
            <th scope="row">Chat Session Price:</th>
            <td>{session_price.chat}</td>
          </tr>
          {audience_session_config &&
            ["personal", "couple", "family"].map((audience) => {
              const entry = audience_session_config[audience];
              if (!entry) return null;
              const label =
                audience === "personal"
                  ? "Personal"
                  : audience === "couple"
                    ? "Couple"
                    : "Family";
              return (
                <tr key={audience}>
                  <th scope="row">{label} Price / Duration:</th>
                  <td colSpan={3}>
                    {["in_person", "video", "call", "chat"].map((mode) => (
                      <div key={`${audience}-${mode}`}>
                        {mode}: 1 {entry?.session_price?.[mode] || "-"}, 3{" "}
                        {entry?.subscription_price?.[mode]?.three_session ||
                          "-"}
                        , 5{" "}
                        {entry?.subscription_price?.[mode]?.five_session ||
                          "-"}
                        , 10{" "}
                        {entry?.subscription_price?.[mode]?.ten_session || "-"}
                        , duration {entry?.duration?.[mode] || "-"} min
                      </div>
                    ))}
                  </td>
                </tr>
              );
            })}
          <tr>
            <th scope="row">Subscription Price for 3 session:</th>
            <td>{three_session}</td>
          </tr>
          <tr>
            <th scope="row">Subscription Price for 5 session:</th>
            <td>{five_session}</td>
          </tr>
          <tr>
            <th scope="row">Subscription Price for 10 session:</th>
            <td>{ten_session}</td>
          </tr>
          <tr>
            <th scope="row">Session Delivery Mode:</th>
            <td colSpan={3}>
              {session_delivery_mode ? session_delivery_mode.join(", ") : ""}
            </td>
          </tr>
          <tr>
            <th scope="row">Tags:</th>
            <td colSpan={3}>{tags ? tags.join(", ") : ""}</td>
          </tr>
          <tr>
            <th scope="row">Type:</th>
            <td colSpan={3}>{type ? type.join(", ") : ""}</td>
          </tr>
          <tr>
            <th scope="row">Rating:</th>
            <td colSpan={3}>{rating}</td>
          </tr>
          <tr>
            <th scope="row">Message title:</th>
            <td>{title}</td>
          </tr>
          <tr>
            <th scope="row">Message detail:</th>
            <td colSpan={3}>{details}</td>
          </tr>
          <tr>
            <th scope="row">Voice note link:</th>
            <td>{voice_note_link}</td>
          </tr>
          <tr>
            <th scope="row">Style:</th>
            <td colSpan={3}>{style ? style.join(", ") : ""}</td>
          </tr>
          <tr>
            <th scope="row">Certifications:</th>
            <td colSpan={3}>
              {certifications ? certifications.join(", ") : ""}
            </td>
          </tr>
          <tr>
            <th scope="row">No. of patients:</th>
            <td colSpan={3}>{no_of_patients}</td>
          </tr>
          <tr>
            <th scope="row">Approach to therapy:</th>
            <td colSpan={3}>{approach_to_therapy}</td>
          </tr>
          <tr>
            <th scope="row">First session:</th>
            <td colSpan={3}>{first_session}</td>
          </tr>
          <tr>
            <th scope="row">gender:</th>
            <td colSpan={3}>{gender}</td>
          </tr>
          <tr>
            <th scope="row">Feedback:</th>
            <td colSpan={3}>
              {feedback
                ? feedback.map((item: any, index: number) => (
                  <li key={index}>{item.name + ":-" + item.text}</li>
                ))
                : ""}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
